import { TemplatePage } from './types';

const eventPromotionPage: TemplatePage = {
  header: {
    color: '#CFE2DC',
    icon: 'images/video-templates/event-promotion.jpg',
    title: 'Event Promotion Video Templates',
    title_meta: '100+ Free and Editable Event Promotion Video Templates',
    description_meta:
      'Get a full house at your online or offline event promoting it with videos. Make event promo clips from ' +
      '100+ customizable video templates.',
    description:
      'Huge concerts or local meetups, online or offline – your events require efficient promotion. These video ' +
      'templates are meant to help you get a full house at your event, regardless of its type and scale.'
  },
  footer: {
    category: 'Event Promotion',
    description:
      'Diverse, stylish and easily customizable, Wave.video’s templates make it easy to continuously produce ' +
      'pro-looking videos for various purposes and multiple channels. All elements of the templates are editable ' +
      'meaning that you can fine-tune them to your use case, message and branding in a matter of minutes.'
  },
  content: [
    {
      type: 'templates',
      title: 'Event Promotion Video',
      search: { category: '/Use Cases/Event Promotion' }
    },
    {
      type: 'stocks',
      title: 'event promotion',
      search: { name: 'event promotion' }
    },
    { type: 'calendar' }
  ]
};

export default eventPromotionPage;
